import { render, staticRenderFns } from "./UploadTtyPremComm.vue?vue&type=template&id=6db10d66&"
import script from "./UploadTtyPremComm.vue?vue&type=script&lang=js&"
export * from "./UploadTtyPremComm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports